var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMy = function SvgMy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.06 0h42.667v32H.06V0z",
    fill: "#E80008"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.06 2.286h42.667v2.286H.06V2.286zM.06 6.857h42.667v2.286H.06V6.857zM.06 11.43h42.667v2.285H.06V11.43zM.06 16h42.667v2.286H.06V16zM.06 20.57h42.667v2.287H.06V20.57zM.06 25.143h42.667v2.286H.06v-2.287zM.06 29.714h42.667V32H.06v-2.286z",
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16.345v9.426H0V0z",
    fill: "#000689"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.298 8.012c-1.76.98-3.957.317-4.907-1.455S3.098 2.57 4.856 1.61c1.087-.59 2.282-.603 3.367-.02-.612-.147-1.16-.14-1.753.037C4.737 2.14 3.743 3.99 4.247 5.75s2.32 2.776 4.05 2.262z",
    fill: "#FE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.265 3.618l1.857-1.055-1.475 1.544 2.13-.145-1.998.75 1.982.795-2.127-.19 1.442 1.575-1.834-1.094.615 2.045L10.68 6.06l-.332 2.11-.287-2.116L8.847 7.81l.66-2.032-1.858 1.055L9.123 5.29l-2.13.144 1.998-.75-1.982-.795 2.127.19-1.442-1.576 1.834 1.094-.615-2.045 1.177 1.782.332-2.11.287 2.117 1.214-1.756z",
    fill: "#FE0"
  })));
};
export default SvgMy;